import { Component } from '@angular/core';

@Component({
  selector: 'mtm-arrow-point-icon',
  templateUrl: './arrow-point-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class ArrowPointIconComponent {}
